import { TFunction } from "i18next";
import { Fields } from "../types/SchemaFactory";
import { schemaFactory } from "./SchemaFactory";
import { ProductFeatureDTO } from "../domain/models/dto/ProductFeatureDTO";

export const productFeaturesFiltersFields: Fields<ProductFeatureDTO> = {
    name: {
        min: 1,
        max: 50,
        placeholderKey: "console.productFeatures.table.name",
        type: "text",
        optional: true,
        initial: "",
    },
    description: {
        min: 1,
        max: 255,
        placeholderKey: "console.productFeatures.table.description",
        type: "text",
        optional: true,
        initial: "",
    },
};

export const productFeaturesFiltersSchemaFactory = (t: TFunction) => {
    return schemaFactory(t, productFeaturesFiltersFields);
};
